import { extendTheme } from "@chakra-ui/react";

const components = {
  Divider: {
    variants: {},
  },
  Heading: {
    variants: {
      pageHeading: {
        textAlign: "center",
        mb: 4,
        mt: 3,
        px: {
          base: 2,
          md: 20,
        },
      },
      h5: {
        fontSize: "md",
        mb: 1,
      },
    },
  },
  Accordion: {
    baseStyle: {
      panel: {
        fontSize: "sm",
      },
    },
  },
  Button: {
    variants: {
      link: {
        color: "blue.500",
        fontSize: "sm",
      },
      secondary: {
        bg: "gray.600",
        color: "#fff",
        _hover: {
          bg: "gray.700",
          boxShadow: "0px 0px 10px #363636",
          _disabled: {
            bgColor: "gray.600",
            boxShadow: "none",
          },
        },
        _focus: { bg: "gray.700" },
        _active: { bg: "gray.700" },
      },
      primary: {
        bg: "blue.500",
        color: "#fff",
        _hover: {
          bg: "blue.600",
          boxShadow: "0px 0px 10px #0027d6",
          _disabled: {
            bgColor: "blue.500",
            boxShadow: "none",
          },
        },
        _focus: { bg: "blue.600" },
        _active: { bg: "blue.600" },
      },
    },
  },
};

const colors = {
  blue: {
    50: "#e2eaff",
    100: "#b1c1ff",
    200: "#7e97ff",
    300: "#4c6dff",
    400: "#1a44ff",
    500: "#0533ff",
    600: "#0021b4",
    700: "#001782",
    800: "#000d51",
    900: "#000521",
  },
};

export const theme = extendTheme({
  components,
  colors,
});
